export enum RequestTypeModel {
  CertificateApproval = 1,
  CourseApproval = 2,
  Queue = 3,
  DraftComplianceCourse = 4,
  UnmatchedPublishingCategory = 5
}